module.exports = __webpack_public_path__ + "img/dosificacion_8.54861cd2.png";